import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area all-products" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex-grow-1 ms-2 position-relative top-1" }
const _hoisted_10 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { class: "text-body" }
const _hoisted_16 = { class: "d-flex align-items-center gap-1" }
const _hoisted_17 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_18 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_19 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_20 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_21 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_22 = { class: "material-symbols-outlined fs-16 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CommonPaginationTwo = _resolveComponent("CommonPaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Member"),
                _createElementVNode("th", { scope: "col" }, "Email"),
                _createElementVNode("th", { scope: "col" }, "Phone"),
                _createElementVNode("th", { scope: "col" }, "Location"),
                _createElementVNode("th", { scope: "col" }, "Joining Date"),
                _createElementVNode("th", { scope: "col" }, "Last Active"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/my-profile",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: item.member.image,
                            class: "wh-34 rounded-circle",
                            alt: "user"
                          }, null, 8, _hoisted_8)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(item.member.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.email), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.phone), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.location), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.joiningDate), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.lastActive), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", _hoisted_17, [
                        _createElementVNode("i", _hoisted_18, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_19, [
                        _createElementVNode("i", _hoisted_20, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_21, [
                        _createElementVNode("i", _hoisted_22, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_CommonPaginationTwo, {
          items: "10",
          total: _ctx.items.length
        }, null, 8, ["total"])
      ])
    ])
  ]))
}